import {Component, Input} from '@angular/core';

@Component({
	selector: 'alert-box',
	templateUrl: './alert-box.component.html'
})
export class AlertBoxWidget {
	@Input() errors:Array<string>;
	@Input() successes:Array<string>;
}



// WEBPACK FOOTER //
// ./src/app/components/widgets/alert-box/alert-box.component.ts